const AUTO_MSG_SETTINGS = {
  AUTO_MSG_HEADER_RETURN_BTN: 'بازگشت',
  AUTO_MSG_HEADER_TITLE_INPUT_PLACEHOLDER: 'عنوان را وارد کنید',

  AUTO_MSG_DESC: 'آیا به دنبال راهی سریع و هوشمند برای آغاز کردن مکالمات هستید؟ هوشمندسازی ابزارک شما، این امکان را به شما می‌دهد!',

  AUTO_MSG_LIST_EMPTY: 'پیامی برای نمایش وجود ندارد',
  AUTO_MSG_NEW_BTN: 'پیام هوشمند جدید',
  AUTO_MSG_GUIDE_LINK: 'راهنمای خوش‌آمدگویی',
  AUTO_MSG_COUNT_LABEL: 'پیام هوشمند',

  AUTO_MSG_TABLE_TITLE_1: 'عنوان',
  AUTO_MSG_TABLE_TITLE_2: 'وضعیت',
  AUTO_MSG_TABLE_TITLE_3: 'ارسال کننده',
  AUTO_MSG_TABLE_TITLE_4: 'آخرین به روزرسانی',
  AUTO_MSG_TABLE_TITLE_5: 'به روزرسانی توسط',
  AUTO_MSG_TABLE_TITLE_6: 'ویرایش و حذف',
  AUTO_MSG_CREATE_BLOCK_TOOLTIP:
    'برای ایجاد پیام هوشمند جدید پکیج خود را ارتقا دهید',
  AUTO_MSG_STATUS_ACTIVE: 'فعال',
  AUTO_MSG_STATUS_INACTIVE: 'غیرفعال',
  AUTO_MSG_DELETE_CONFIRM_MSG: 'آیا از حذف این پیام اطمینان دارید؟',
  AUTO_MSG_DELETE_CONFIRM_CONFIRM: 'تایید',
  AUTO_MSG_UNKNOWN_LABEL: 'نامشخص',
  AUTO_MSG_FORM_CONTENT_TAB: 'محتوا',
  AUTO_MSG_FORM_CONDITION_TAB: 'شرط',
  AUTO_MSG_FORM_PUBLISH_TAB: 'زمان انتشار',
  AUTO_MSG_SEND_TYPE_COMPLETE: 'پیام کامل',
  AUTO_MSG_SEND_TYPE_COMPLETE_DESC: 'پیام به صورت کامل نمایش داده می‌شود',
  AUTO_MSG_SEND_TYPE_SHORT: 'پیام کوتاه',
  AUTO_MSG_SEND_TYPE_SHORT_DESC: 'خلاصه‌ای از متن پیام نمایش داده می‌شود',
  AUTO_MSG_SEND_TYPE_NOTIF: 'اعلان',
  AUTO_MSG_SEND_TYPE_NOTIF_DESC: 'نمایش دایره کوچک در بالای ابزارک',
  AUTO_MSG_ACTION_SECTION_LABEL: 'این عملیات انجام شود',
  AUTO_MSG_SPIN_ACTION: 'چرخش ابزارک',
  AUTO_MSG_OPEN_WIDGET_ACTION: 'ابزارک باز شود',
  AUTO_MSG_CLOSE_WIDGET_ACTION: 'ابزارک بسته شود',
  AUTO_MSG_SHORT_MSG_ACTION:
    'پیام ارسال شود اما ابزارک  باز نشود (نمایش کوتاه پیام)',
  AUTO_MSG_OPEN_SEND_ACTION: 'ابزارک باز شده و پیام ارسال شود',
  AUTO_MSG_SWITCH_JUST_ONCE: 'برای هر بازدیدکننده یک بار ارسال',
  AUTO_MSG_SWITCH_MUTE: 'ارسال به همراه صدا',
  AUTO_MSG_SWITCH_MOBILE: 'در موبایل نیز ارسال شود',
  AUTO_MSG_SEND_TYPE_TITLE: 'ارسال به عنوان',
  AUTO_MSG_SEND_FROM: 'ارسال پیام از سمت',
  AUTO_MSG_CONDITION_TITLE: 'در چه شرایطی ارسال شود',
  AUTO_MSG_CONDITION_NUM_ALL: 'همه‌ی شرط‌های زیر رخ دهد',
  AUTO_MSG_CONDITION_NUM_LEAST_ONE: 'حداقل یکی از شرط‌های زیر رخ دهد',

  AUTO_MSG_CONDITION_TYPE_TIME: 'زمان در صفحه',
  AUTO_MSG_CONDITION_TYPE_TITLE: 'عنوان صفحه',
  AUTO_MSG_CONDITION_TYPE_ADDRESS: 'آدرس صفحه',

  AUTO_MSG_CONDITION_EQUAL: 'برابر باشد',
  AUTO_MSG_CONDITION_NOT_EQUAL: 'برابر نباشد',
  AUTO_MSG_CONDITION_START: 'آغاز شود',
  AUTO_MSG_CONDITION_END: 'پایان یابد',
  AUTO_MSG_CONDITION_INCLUDE: 'شامل باشد',
  AUTO_MSG_CONDITION_NOT_INCLUE: 'شامل نباشد',
  AUTO_MSG_MAX_CONDITION_REACHED:
    'برای شرط‌های بیشتر پکیج خود را به پریمیوم ارتقا دهید.',
  AUTO_MSG_CONDITION_SELECT_TITLE: 'انتخاب شرط',
  AUTO_MSG_TITLE_INPUT_PLACEHOLDER: 'عنوان',
  AUTO_MSG_ADDRESS_INPUT_PLACEHOLDER: ' آدرس صفحه https://example.com',
  AUTO_MSG_TIME_INPUT_PLACEHOLDER: 'ثانیه',

  AUTO_MSG_PUBLISH_START_TITLE: 'شروع به ارسال',
  AUTO_MSG_PUBLISH_START_CUSTOM: 'تنظیم زمان خاص',
  AUTO_MSG_PUBLISH_END_TITLE: 'پایان ارسال',
  AUTO_MSG_PUBLISH_END_NEVER: 'هیچ وقت',
  AUTO_MSG_PUBLISH_END_CUSTOM: 'تنظیم زمان خاص',
  AUTO_MSG_PUBLISH_WHEN_TITLE:
    'تنظیم روز و ساعت‌هایی که این چت میتواند ارسال شود',
  AUTO_MSG_PUBLISH_WHEN_ANYTIME: 'هر روز هر ساعتی',
  AUTO_MSG_PUBLISH_WHEN_OFFICE: 'در طول زمان‌های کاری',
  AUTO_MSG_PUBLISH_WHEN_NON_OFFICE: 'در طول زمان‌های غیرکاری',

  //Preview
  AUTO_MSG_PREVIEW_CONTENT_TITLE: 'محتوا',
  AUTO_MSG_PREVIEW_CONDITION_TITLE: 'شرط',
  AUTO_MSG_PREVIEW_PUBLISH_TITLE: 'زمان انتشار',
  AUTO_MSG_PREVIEW_CONTENT_BADGE_COMPLETE: 'پیام کامل',
  AUTO_MSG_PREVIEW_CONTENT_BADGE_NOTIF: 'اعلان',
  AUTO_MSG_PREVIEW_CONTENT_BADGE_SHORT: 'پیام کوتاه',
  AUTO_MSG_PREVIEW_BADGE_UNDEFINED: 'تعریف نشده',
  AUTO_MSG_MESSAGE_TITLE: 'متن پیام',
  AUTO_MSG_OPERATOR_SELECT_RANDOM: 'انتخاب تصادفی',
  AUTO_MSG_PREVIEW_TIME_CONDITION: 'زمان در صفحه جاری',
  AUTO_MSG_PREVIEW_ADDRESS_CONDITION: 'آدرس صفحه برابر باشد با',
  AUTO_MSG_PREVIEW_TITLE_CONDITION: 'عنوان صفحه برابر باشد با',
  AUTO_MSG_PREVIEW_SECONDS: 'ثانیه',

  AUTO_MSG_PREVIEW_PUBLISH_NOW: 'همین الان',
  AUTO_MSG_PREVIEW_PUBLISH_NEVER: 'هیچوقت',
  AUTO_MSG_PREVIEW_PUBLISH_ANYTIME: 'هر روز هر ساعتی',
  AUTO_MSG_PREVIEW_PUBLISH_NON_OFFICE: 'در طول زمان‌های غیرکاری',
  AUTO_MSG_PREVIEW_PUBLISH_OFFICE: 'در طول زمان‌های کاری',
  AUTO_MSG_PREVIEW_PUBLISH_CUSTOM: 'تنظیم زمان خاص',

  AUTO_MSG_PREVIEW_START_PUBLISH: 'شروع ارسال',
  AUTO_MSG_PREVIEW_END_PUBLISH: 'پایان ارسال',

  AUTO_MSG_EDITOR_REMAINING_CHAR: 'کاراکتر باقی مانده',
  AUTO_MSG_EDITOR_PLACEHOLDER: 'پیام خودکار',

  AUTO_MSG_SAVEBAR_SUBMIT: 'انتشار',
  AUTO_MSG_SAVEBAR_EDIT: 'ویرایش',
};

export default AUTO_MSG_SETTINGS;
